// inv/src/components/ui/inputSearch.jsx
import { useState, useEffect, useRef } from "react";
import CountryFlag from "../countryFlags/countryFlag";
import { cn } from "../../lib/utils";

const InputSearch = ({
  options = [],
  selectedValue = "",
  onChange,
  placeholder = "Search and select...",
  className,
  showCountryFlags = false,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const filteredOptions = options.filter((option) =>
    option.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleOptionClick = (option) => {
    onChange(option);
    setShowDropdown(false);
    setSearchTerm("");
  };

  const handleRemoveSelected = () => {
    onChange("");
  };

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    if (!showDropdown) setShowDropdown(true);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={cn("relative w-full", className)}>
      <div
        className={cn(
          "flex flex-wrap items-center gap-2 px-2 py-1 rounded-md border border-stone-300 bg-transparent shadow-sm transition-colors focus-within:ring-1 focus-within:ring-stone-200",
          className
        )}
        style={{ minHeight: "1.6rem" }}
      >
        {selectedValue ? (
          <div
            className="flex items-center px-2 py-1 bg-stone-700 text-white  rounded-md text-sm"
            style={{ maxHeight: "1.6rem" }}
          >
            {showCountryFlags ? (
              <CountryFlag
                countryName={selectedValue}
                className="mr-1 h-4 w-5 flex-none rounded-sm"
              />
            ) : null}
            <span className="mr-1">{selectedValue}</span>
            <button
              onClick={handleRemoveSelected}
              className="cursor-pointer text-white  hover:text-gray-300"
            >
              &times;
            </button>
          </div>
        ) : (
          <input
            type="text"
            value={searchTerm}
            onChange={handleInputChange}
            onFocus={() => setShowDropdown(true)}
            placeholder={placeholder}
            className="flex-1 bg-transparent outline-none text-sm placeholder:text-muted-foreground"
            style={{
              minWidth: "150px",
              flexGrow: 1,
              height: "1.6rem",
            }}
          />
        )}
      </div>

      {showDropdown && filteredOptions.length > 0 && (
        <div
          ref={dropdownRef}
          className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto"
          style={{ top: "100%" }}
        >
          {filteredOptions.map((option, index) => (
            <div
              key={index}
              className="m-1 flex items-center gap-2 rounded-md px-4 py-2 text-sm text-stone-700 hover:bg-stone-200 cursor-pointer"
              onClick={() => handleOptionClick(option)}
            >
              {showCountryFlags ? (
                <CountryFlag
                  countryName={option}
                  className="h-4 w-5 flex-none rounded-sm"
                />
              ) : null}
              <span className="truncate">{option}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export { InputSearch };
